import { TargetFormConfiguration } from '../../interfaces/api/forms-config.interface';
import {
  FormFieldSections,
  HeroCasinoForm,
} from '../../interfaces/ui/page-section-object.interface';
import { BadgeStyleConfig } from './../../interfaces/ui/ui.interface';

export const TOURNAMENT_MANAGEMENT_COLUMNS = [
  {
    name: 'pageManagement.tournamentManagement.totalEvents',
    prop: 'eventCount',
    width: 150,
  },
];

export const PLAYER_PAGES = {
  HOME: { id: 'home', value: 'pageManagement.sectionManagement.pages.home' },
  SPORT: { id: 'sport', value: 'pageManagement.sectionManagement.pages.sport' },
  CASINO: {
    id: 'casino',
    value: 'pageManagement.sectionManagement.pages.casino',
  },
  LIVE_CASINO: {
    id: 'live casino',
    value: 'pageManagement.sectionManagement.pages.liveCasino',
  },
  PROMOTIONS: {
    id: 'promotions',
    value: 'pageManagement.sectionManagement.pages.promotions',
  },
};

export const PAGE_SECTIONS = {
  HERO_MULTIPLE_SLIDER: {
    layout: 'hero-multiple-slider',
    title: 'Hero Multiple Slider',
    page: PLAYER_PAGES.HOME,
  },
  CATEGORY_HOME_SLIDER: {
    layout: 'category-home-slider',
    title: 'Category Home Slider',
    page: PLAYER_PAGES.HOME,
  },
  CASINO_SLIDER_GRID_GAMES: {
    layout: 'casino-slider-grid-games',
    title: 'Gasino Slider Grid Games',
    page: PLAYER_PAGES.HOME,
  },
  SLIDER_PROMOTIONS: {
    layout: 'slider-promotions',
    title: 'Slider Promotions',
    page: PLAYER_PAGES.HOME,
  },
  PROMOTIONS_GRID: {
    layout: 'promotions-grid',
    title: 'Promotions Grid',
    page: PLAYER_PAGES.HOME,
  },
  TOP_TEN_CASINO: {
    layout: 'top-ten-casino',
    title: 'Top Ten Casino',
    page: PLAYER_PAGES.HOME,
  },
  CASINO_GRID: {
    layout: 'casino-grid',
    title: 'Casino Grid',
    page: PLAYER_PAGES.HOME,
  },
  STATIC_BANNERS: {
    layout: 'static-banners',
    title: 'Static Banners',
    page: PLAYER_PAGES.HOME,
  },
  BANNER_GRID: {
    layout: 'banner-grid',
    title: 'Banner Grid',
    page: PLAYER_PAGES.HOME,
  },
  CATEGORY_CARDS: {
    layout: 'category-cards',
    title: 'Category Cards',
    page: PLAYER_PAGES.HOME,
  },
  BETTING_CARDS: {
    layout: 'betting-card',
    title: 'Betting Cards',
    page: PLAYER_PAGES.HOME,
  },
  HOME_SLIDER: {
    layout: 'home-slider',
    title: 'Home Slider',
    page: PLAYER_PAGES.HOME,
  },
  REGISTER_USER: {
    layout: 'register-user',
    title: 'Register User',
    page: PLAYER_PAGES.HOME,
  },
  POP_UP_AFTER_REGISTER: {
    layout: 'pop-up-after-register',
    title: 'Popup after register',
    page: PLAYER_PAGES.HOME,
  },
  SPORT_LEFT_BANNER: {
    layout: 'sport-left-banner',
    title: 'Sport Left Banner',
    page: PLAYER_PAGES.SPORT,
  },
  SPORT_RIGHT_BANNER: {
    layout: 'sport-right-banner',
    title: 'Sport Right Banner',
    page: PLAYER_PAGES.SPORT,
  },
  //todo: delete this option
  CASINO_HERO_SLIDER: {
    layout: 'casino-hero-slider',
    title: 'Casino Hero Slider',
    page: PLAYER_PAGES.CASINO,
  },
  CASINO_ANIMATED_HERO_SLIDER: {
    layout: 'casino-animated-hero-slider',
    title: 'Casino Animated Hero Slider',
    page: PLAYER_PAGES.CASINO,
  },
  CASINO_CATEGORIES_IMAGES: {
    layout: 'casino-categories-images',
    title: 'Casino Categories Images',
    page: PLAYER_PAGES.CASINO,
  },
  CASINO_CATEGORY_PARALLAX: {
    layout: 'casino-category-parallax',
    title: 'Casino Category Parallax',
    page: PLAYER_PAGES.CASINO,
  },
  CASINO_PROVIDER_SHOWCASE: {
    layout: 'casino-provider-showcase',
    title: 'Casino Provider Showcase',
    page: PLAYER_PAGES.CASINO,
  },
  LIVE_CASINO_HERO_SLIDER: {
    layout: 'live_casino-hero-slider',
    title: 'Live Casino Hero Slider',
    page: PLAYER_PAGES.LIVE_CASINO,
  },
  LIVE_CASINO_CATEGORY_PARALLAX: {
    layout: 'live-casino-category-parallax',
    title: 'Live Casino Category Parallax',
    page: PLAYER_PAGES.LIVE_CASINO,
  },
  LIVE_CASINO_ANIMATED_HERO_SLIDER: {
    layout: 'live-casino-animated-hero-slider',
    title: 'Live Casino Animated Hero Slider',
    page: PLAYER_PAGES.LIVE_CASINO,
  },
  LIVE_CASINO_PROVIDER_SHOWCASE: {
    layout: 'live-casino-provider-showcase',
    title: 'Live Casino Provider Showcase',
    page: PLAYER_PAGES.LIVE_CASINO,
  },
  PROMOTION_ANIMATED_HERO_SLIDER: {
    layout: 'promotion-animated-hero-slider',
    title: 'Promotion Animated Hero Slider',
    page: PLAYER_PAGES.PROMOTIONS,
  },
};

export const ANIMATIONS = [
  { label: 'jump', value: 'jump' },
  { label: 'spin', value: 'spin' },
  { label: 'grow', value: 'grow' },
];

export const SECTION_NG_SELECT_ICONS = [
  {
    label: 'live',
    value: 'live',
  },
  {
    label: 'casino',
    value: 'casino',
  },
  {
    label: 'curved-up-arrow',
    value: 'curved-up-arrow',
  },
  {
    label: 'betting-history',
    value: 'betting-history',
  },
  {
    label: 'today',
    value: 'today',
  },
  {
    label: 'gift-bonus',
    value: 'gift-bonus',
  },
  {
    label: 'soccer-uno',
    value: 'soccer-uno',
  },
];

export const MAX_FILE_SIZE_IN_MB = 1;

export const BYTES_PER_MB = 1024 * 1024;

export const WELCOME_IMAGE_ROLES = [
  { key: 'Guest', label: 'pageManagement.roles.guest', required: true, icon: 'fa-user-o' },
  { key: 'Agents', label: 'pageManagement.roles.agent', required: false, icon: 'fa-user-secret' },
  {
    key: 'Affiliate',
    label: 'pageManagement.roles.affiliate',
    required: false,
    icon: 'fa-handshake-o',
  },
];

export const FORM_FIELD_SECTIONS: FormFieldSections = {
  SECTION_NAME: 'sectionName',
  SECTION_TITLE: { es: 'sectionTitleEs', en: 'sectionTitleEn' },
  SECTION_URL: { es: 'sectionUrlEs', en: 'sectionUrlEn' },
  WIDTH: { es: 'widthEs', en: 'widthEn' },
  HEIGHT: { es: 'heightEs', en: 'heightEn' },
  KEEP_ASPECT: { es: 'keepAspectEs', en: 'keepAspectEn' },
  IMAGE_TITLE: { es: 'imageTitleEs', en: 'imageTitleEn' },
  IMAGE_ALT: { es: 'imageAltEs', en: 'imageAltEn' },
  URL: { es: 'urlEs', en: 'urlEn' },
  IMAGE: { es: 'imageEs', en: 'imageEn' },
  IS_SHOWED_DESKTOP: { es: 'isShowedInDesktopEs', en: 'isShowedInDesktopEn' },
  IS_SHOWED_MOBILE: { es: 'isShowedInMobileEs', en: 'isShowedInMobileEn' },
  TITLE: { es: 'titleEs', en: 'titleEn' },
  DESCRIPTION: { es: 'descriptionEs', en: 'descriptionEn' },
  BUTTON_TITLE: { es: 'buttonTitleEs', en: 'buttonTitleEn' },
  BUTTON_URL: { es: 'buttonUrlEs', en: 'buttonUrlEn' },
  IS_EXTERNAL_LINK: { es: 'isExternalLinkEs', en: 'isExternalLinkEn' },
  CASINO_CATEGORY: { es: 'casinoCategoryEs', en: 'casinoCategoryEn' },
  BACKGROUND_IMAGE: { es: 'backgroundImageEs', en: 'backgroundImageEn' },
  SLOGAN: { es: 'sloganEs', en: 'sloganEn' },
};

export const FORM_FIELDS_HERO_CASINO: HeroCasinoForm = {
  TITLE: { es: 'titleEs', en: 'titleEn' },
  DESCRIPTION: { es: 'descriptionEs', en: 'descriptionEn' },
  IMAGE: { es: 'imageEs', en: 'imageEn' },
  BUTTON_TITLE: { es: 'buttonTitleEs', en: 'buttonTitleEn' },
  BUTTON_URL: { es: 'buttonUrlEs', en: 'buttonUrlEn' },
};

export const DEFAULT_CASINO_CATEGORIES = [
  {
    gameQuantity: 1,
    nameCategory: 'Most Bet',
  },
  {
    gameQuantity: 1,
    nameCategory: 'Most Played Games',
  },
  {
    gameQuantity: 1,
    nameCategory: 'All Games',
  },
];

export const OTP_BADGE_STATUS = {
  AVAILABLE: 'available',
} as const;

export const OTP_BADGE_OPTIONS: Record<string, BadgeStyleConfig> = {
  [OTP_BADGE_STATUS.AVAILABLE]: {
    color: '#f97316',
    es: 'OTP disponible',
    en: 'OTP available',
    icon: 'shield',
  },
};

export const FORM_FIELD_TYPES = {
  PASSWORD: 'password',
  OCR: 'ocr',
  TEXT: 'text',
  EMAIL: 'email',
  DATE: 'date',
  SELECT: 'select',
  RADIO_CARD: 'radio-card',
} as const;

export const EMPTY_TARGET_FORM_CONFIGURATION: TargetFormConfiguration = {
  templates: [],
  optionalFields: [],
  requiredFields: [],
  templateOptions: [],
};
